<template>
  <div id="cart">
    <SfSidebar v-e2e="'sidebar-cart'" :visible="isCartSidebarOpen" :title="$t('cart_title')" class="sf-sidebar--right"
      @close="toggleCartSidebar">
      <template #content-top>
        <SfProperty v-if="totalItems" class="sf-property--large cart-summary desktop-only" :name="$t('total_items')"
          :value="totalItems" />
      </template>
      <transition name="sf-fade" mode="out-in">
        <div v-if="totalItems" key="my-cart" class="my-cart">
          <div class="collected-product-list">
            <transition-group name="sf-fade" tag="div">
              <Sf-collected-product v-for="product in products" v-e2e="'collected-product'"
                :key="cartGetters.getItemSku(product)" :image="addBasePath(cartGetters.getItemImage(product))"
                 :regular-price="
                  $n(cartGetters.getItemPrice(product).regular, 'currency')
                " :special-price="
                  cartGetters.getItemPrice(product).special &&
                  $n(cartGetters.getItemPrice(product).special, 'currency')
                " :stock="99999" @click:remove="removeItemEvent(product)" class="collected-product">
                <template #actions>
                  <div></div>
                </template>
                <template #configuration>
                  <div class="collected-product__properties" style="height:40px;">
                    <!-- <SfProperty v-for="(attribute, key) in cartGetters.getItemAttributes(
                        product,
                        []
                      )" :key="key" :name="key" :value="attribute" style="flex-wrap: wrap;" /> -->
                  </div>
                </template>
                <template #input>
                  <div style="position: absolute;bottom: 1rem;width: 100%;">
                    <SfQuantitySelector :disabled="loading" :qty="cartGetters.getItemQty(product)"
                       style="margin: 0 auto" @input="
                        updateQuantity({
                          product: {
                            id: product.id,
                            skuId: product.skuId,
                          },
                          quantity: Number($event),
                        })
                      " />
                  </div>
                </template>
                <template #title>
                  <div>
                    <div class="sf-collected-product__title ">{{ cartGetters.getItemName(product) }}</div>
                    <div>
                      <div style="min-height:40px;">
                        <div  v-for="(attribute, key) in cartGetters.getItemAttributes(
                            product,
                            []
                          )" style="margin-bottom:0.5rem;line-height: 1.5;">
                          <div>{{ key }}: </div>
                          <div>{{ attribute }}</div>
                        </div>
                        <!-- <SfProperty v-for="(attribute, key) in cartGetters.getItemAttributes(
                            product,
                            []
                          )" :key="key" :name="key" :value="attribute" style="flex-wrap: wrap;" /> -->
                      </div>
                    </div>
                    <div>
                      <wholesale :id="product.goodId" size="mini" />
                    </div>
                    <div style="height:40px">
                      <SfButton class="sf-button--text desktop-only sf-button" @click="saveForLater(product)">
                        {{ $t('CartSliderTextBtn') }}
                      </SfButton>
                    </div>
                  </div>
                </template>
              </Sf-collected-product>
            </transition-group>
          </div>
        </div>
        <div v-else key="empty-cart" class="empty-cart">
          <div class="empty-cart__banner">
            <SfImage alt="Empty bag" class="empty-cart__image" :src="addBasePath('/icons/empty-cart.svg')" :width="96"
              :height="100" />
            <SfHeading :title="$t('cart_empty_title')" :level="2" class="empty-cart__heading"
              :description="$t('cart_empty_desc')" />
          </div>
        </div>
      </transition>
      <template #content-bottom>
        <transition name="sf-fade">
          <div v-if="totalItems">
            <SfProperty :name="$t('cart_price')"
              class="sf-property--full-width sf-property--large my-cart__total-price">
              <template #value>
                <SfPrice :regular="$n(totals.special || 0, 'currency')" />
              </template>
            </SfProperty>
            <nuxt-link :to="goPayLink()" >
              <SfButton class="sf-button--full-width " @click="clickCheckout">
                {{ $t('Go_to_checkout') }}
              </SfButton>
            </nuxt-link>
            <!-- <SfButton class="sf-button--full-width sf-button--text" style="margin-top: var(--spacer-sm);" @click="clearCart">
              {{ $t('cart_clear') }}
            </SfButton> -->
          </div>
          <div v-else>
            <SfButton class="sf-button--full-width color-primary" @click="toggleCartSidebar">{{ $t('Go_back_shopping')
              }}
            </SfButton>
          </div>
        </transition>
      </template>
    </SfSidebar>
  </div>
</template>
<script>
import {
  SfSidebar,
  SfHeading,
  SfButton,
  SfIcon,
  SfProperty,
  SfPrice,
  SfCollectedProduct,
  SfImage,
  SfQuantitySelector
} from '@storefront-ui/vue';
import { computed, watch } from '@nuxtjs/composition-api';
import {
  useOCart,
  cartGetters,
  useUser,
  useWishlist,
  userMessage
} from '@bee-hole/coms';
import { useUiState } from '~/composables';
import debounce from 'lodash.debounce';
import { addBasePath } from '@vue-storefront/core';
import { EventBus } from '@/plugins/eventBus';
import wholesale from '~/components/Products/wholesale.vue';
export default {
  name: 'Cart',
  components: {
    SfSidebar,
    SfButton,
    SfHeading,
    SfIcon,
    SfProperty,
    SfPrice,
    SfCollectedProduct,
    SfImage,
    SfQuantitySelector,
    wholesale
  },
  setup(p, context) {
    const { isCartSidebarOpen, toggleCartSidebar } = useUiState();
    const { cart, removeItem, updateItemQty, loading, load, clear } =
      useOCart();
    const { addItem: addItemToWishlist, wishlist: currentWishlist } =
      useWishlist();
    const { unReadMsg } = userMessage();
    const products = computed(() => cartGetters.getItems(cart.value));
    const totals = computed(() => cartGetters.getTotals(cart.value));
    const { user, isAuthenticated } = useUser();
    const totalItems = computed(() => {
      return cartGetters.getTotalItems(cart.value);
    });
    const updateQuantity = debounce(async ({ product, quantity }) => {
      await updateItemQty({ product, quantity });
      EventBus.$emit('PreviewOrder', cart.value);
      EventBus.$emit('NewPreviewOrder', cart.value);
    }, 500);

    const saveForLater = async (product) => {
      await addItemToWishlist({ currentWishlist, product });
      await removeItem({
        customQuery: {
          id: product.id,
          sku_id: product.skuId
        }
      });
      load();
      EventBus.$emit('PreviewOrder', cart.value);
      EventBus.$emit('NewPreviewOrder', cart.value);
    };
    const clearCart = async () => {
      await clear();
      EventBus.$emit('PreviewOrder', cart.value);
      EventBus.$emit('NewPreviewOrder', cart.value);
    };
    watch(user, async () => {
      if (isAuthenticated.value && user.value && user.value.memberId) {
        await load();
        await unReadMsg();
        EventBus.$emit('PreviewOrder', cart.value);
        EventBus.$emit('NewPreviewOrder', cart.value);
      }
    });
    const goCheckoutType = computed(() => {
      return context?.root?.$options?.$storeConfig?.mall_shouhou_config?.checkout || '1';
    });
    const googleBeginChckout = ()=>{
      context.root.$gtm.push({
        event: "begin_checkout",
        ecommerce: null,
      });
      const googleItem ={
        event: "begin_checkout",
        ecommerce: {
          currency: context?.root?.$cookies?.get('vsf-currency'),
          value: totals.value.special,
          items: [
          ]
        }
      }
      products.value?.map((product)=>{
        // product.properties object变成array
          const properties = Object.keys(JSON.parse(JSON.stringify(product.properties))).map((key)=>{
            return `${key}:${product.properties[key]}`
          })
          googleItem.ecommerce.items.push({
            item_id: product.id,
            item_name: product.title,
            item_variant: properties.join(','),
            price: product.price,
            quantity: product.num
          })
        })
      
      context.root.$gtm.push(googleItem);
    }
    const goPayLink = () => {
      
      if (goCheckoutType.value === '1') {
        return context.root.localePath({ name: 'shipping' });
      } else {
        return context?.root.localePath("/checkouts");
      }
    };
    const removeItemEvent = async (product) => {
      console.log('1', product);
      await removeItem({
        customQuery: {
          id: product.id,
          sku_id: product.skuId
        }
      });
      EventBus.$emit('PreviewOrder', cart.value);
      EventBus.$emit('NewPreviewOrder', cart.value);
      // await load();
    };
    const clickCheckout = () => {
      googleBeginChckout();
      toggleCartSidebar();
    }
    return {
      saveForLater,
      addBasePath,
      updateQuantity,
      loading,
      products,
      removeItem,
      isCartSidebarOpen,
      toggleCartSidebar,
      totals,
      totalItems,
      cartGetters,
      clearCart,
      goPayLink,
      removeItemEvent,
      clickCheckout
    };
  }
};
</script>

<style lang="scss" scoped>
#cart {
  --c-text: #000;
  --sidebar-z-index: 99999999999;
  --overlay-z-index: 3;

  @include for-desktop {
    & > * {
      --sidebar-bottom-padding: var(--spacer-base);
      --sidebar-content-padding: var(--spacer-base);
    }
  }
}

.cart-summary {
  margin-top: var(--spacer-xl);
}

.my-cart {
  flex: 1;
  display: flex;
  flex-direction: column;

  &__total-items {
    margin: 0;
  }

  &__total-price {
    --price-font-size: var(--font-size--xl);
    --price-font-weight: var(--font-weight--medium);
    margin: 0 0 var(--spacer-base) 0;
  }
}

.empty-cart {
  --heading-description-margin: 0 0 var(--spacer-xl) 0;
  --heading-title-margin: 0 0 var(--spacer-xl) 0;
  --heading-title-color: var(--c-primary);
  --heading-title-font-weight: var(--font-weight--semibold);
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;

  &__banner {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    flex: 1;
  }

  &__heading {
    padding: 0 var(--spacer-base);
  }

  &__image {
    --image-width: 16rem;
    margin: 0 0 var(--spacer-2xl) 7.5rem;
  }

  @include for-desktop {
    --heading-title-font-size: var(--font-size--xl);
    --heading-title-margin: 0 0 var(--spacer-sm) 0;
  }
}

.collected-product-list {
  flex: 1;
}

.collected-product {
  margin: 0 0 var(--spacer-sm) 0;

  &__properties {
    margin: var(--spacer-xs) 0 0 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    flex: 2;

    &:first-child {
      margin-bottom: 8px;
    }
  }

  &__actions {
    transition: opacity 150ms ease-in-out;
  }

  &__save,
  &__compare {
    --button-padding: 0;

    &:focus {
      --cp-save-opacity: 1;
      --cp-compare-opacity: 1;
    }
  }

  &__save {
    opacity: var(--cp-save-opacity, 0);
  }

  &__compare {
    opacity: var(--cp-compare-opacity, 0);
  }

  &:hover {
    --cp-save-opacity: 1;
    --cp-compare-opacity: 1;

    @include for-desktop {
      .collected-product__properties {
        display: none;
      }
    }
  }
}
</style>
<style lang="scss">
.image-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  padding: 20px;
}

.sf-image--wrapper {
  display: block;
  margin: auto;
}

.empty-cart__image {
  margin: 20px !important;
  width: 30%;

  .sf-image {
    width: 100%;
    display: flex;
    color: gray;
  }
}
#cart{
  .sf-collected-product{
    &__title{
      margin: var(--collected-product-title-margin, 0 var(--spacer-base) var(--spacer-xs) 0)
    }
  }
  .sf-collected-product__configuration{
    margin-top:0;
  }
  .sf-property{
    &__value{
      flex: 1;
    }
  }
}
</style>
